/* ================================================== */
/* FLICKITY > Shortly
/* ================================================== */

function flickityShortly() {

	var $carousels = $('.carousel--shortly');

	if ($carousels.length) {

		$carousels.each(function(index, element){

			var total = $(this).data('total');

			// Init
			var $carousel = $(element).flickity({
				cellSelector        : '.carousel__item',
				autoPlay            : 4000,
				pauseAutoPlayOnHover: true,
				setGallerySize      : false,
				contain             : true,
				wrapAround          : true,
				draggable           : true,
				freeScroll          : true,
				pageDots            : false,
				imagesLoaded        : true
			});

			// Refresh on image load
			$(element).imagesLoaded().progress(function(instance, image) {
				$carousel.flickity('resize');
			});

			// Refresh on resize
			$(window).on('scroll resize orientationchange', function() {
				$carousel.flickity('resize');
			});

			// Load
			$carousel.addClass('loaded');

			// Controls
			flickityControls($carousel);

			// Accessibility
			flickityDotsAccessibility($carousel);

		});

		// Accessibility
		flickityAccessibility();

	}

}

$(document).ready(flickityShortly());